import React, { memo, ReactElement } from "react";

export interface CloseIconProps {
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    size?: number;
    dataTestId?: string;
    stroke?: string;
    opacity?: string;
}

const CLOSE = "click here to close";

function CloseIcon(props: CloseIconProps): ReactElement {
    const { className, onClick = (): null => null, dataTestId } = props;

    return (
        <button className={className} onClick={onClick} aria-label={CLOSE} data-testid={dataTestId}>
            <svg
                width={props.size ?? 16}
                height={props.size ?? 16}
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="8" cy="8" r="8" fill="grey" fillOpacity={0.5} />
                <g clipPath="url(#clip0_2791_18396)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.19107 5.19917C5.91771 4.9258 5.4745 4.9258 5.20113 5.19916C4.92775 5.47252 4.92775 5.91574 5.20111 6.18911L7.01052 7.99856L5.20122 9.80791C4.92786 10.0813 4.92786 10.5245 5.20123 10.7979C5.4746 11.0712 5.91782 11.0712 6.19118 10.7978L8.00046 8.98852L9.80973 10.7978C10.0831 11.0712 10.5263 11.0712 10.7997 10.7979C11.0731 10.5245 11.0731 10.0813 10.7997 9.80791L8.99039 7.99856L10.7998 6.18911C11.0732 5.91574 11.0732 5.47252 10.7998 5.19916C10.5264 4.9258 10.0832 4.9258 9.80984 5.19917L8.00046 7.0086L6.19107 5.19917Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_2791_18396">
                        <rect width="6.66294" height="6.66294" fill="white" transform="translate(4.66797 4.66699)" />
                    </clipPath>
                </defs>
            </svg>
        </button>
    );
}

export default memo(CloseIcon);
